import axiosInstance from "api/axiosInstance";

import type { LoginRequest, LoginResponse } from "api/types/auth.types";

export const authService = {
  /** 로그인 — 성공 시 토큰·유저 정보를 localStorage에 저장, is_admin 아니면 에러 */
  login: async (payload: LoginRequest): Promise<LoginResponse> => {
    const { data } = await axiosInstance.post<LoginResponse>("/server/buccl_user/auth/", payload);
    const access = data.token?.access;
    // 브라우저 요청은 refresh를 HttpOnly 쿠키로만 내려주므로 body에 없을 수 있음.
    // 값이 있을 때만 저장해 "undefined" 문자열이 들어가는 것을 방지한다.
    const refresh = data.token?.refresh;
    if (access) localStorage.setItem("access_token", access);
    if (refresh) localStorage.setItem("refresh_token", refresh);

    // 관리자 권한 확인 (is_admin, is_staff, is_superuser 중 하나)
    const user = data.user;
    const isAdmin = user?.is_admin ?? false;
    if (!isAdmin) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("buccl_admin");
      throw new Error("관리자 권한이 없습니다. 관리자 계정으로 로그인해주세요.");
    }

    localStorage.setItem("buccl_admin", JSON.stringify(user));
    return data;
  },

  /** 로그아웃 — 클라이언트 토큰·유저 정보 삭제 */
  logout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("buccl_admin");
  },

  /** 로그인 상태 확인 */
  isLoggedIn: () => !!localStorage.getItem("access_token"),

  /** 저장된 유저 정보 반환 */
  getUser: () => {
    try {
      const raw = localStorage.getItem("buccl_admin");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  /** 관리자 권한 확인 */
  isAdmin: () => {
    const user = authService.getUser();
    return !!(user?.is_admin || false);
  },
};
